import { mouseEventToCoordinates, touchEventToCoordinates, hasSelection, SwipeDirection, SWIPE_THRESHOLD, targetElementIsInteractive } from '../helpers/SwipeHelper';
export class SwipeService {
    constructor() {
        this.swipeStartCoords = null;
        this.swipeData = null;
        this.canSwipe = () => this.assetViewer.canNavigateToNext() || this.assetViewer.canNavigateToPrevious();
        this.onMouseDown = (event) => {
            if (!targetElementIsInteractive(event)) {
                this.onSwipeStart(mouseEventToCoordinates(event));
            }
        };
        this.onMouseMove = (event) => {
            this.onSwipeMove(mouseEventToCoordinates(event));
        };
        this.onMouseUp = (event) => {
            this.onSwipeEnd(mouseEventToCoordinates(event));
        };
        this.onTouchStart = (event) => {
            if (!targetElementIsInteractive(event)) {
                this.onSwipeStart(touchEventToCoordinates(event));
            }
        };
        this.onTouchMove = (event) => {
            this.onSwipeMove(touchEventToCoordinates(event));
        };
        this.onTouchEnd = (event) => {
            this.onSwipeEnd(touchEventToCoordinates(event));
        };
        this.onSwipeStart = (coords) => {
            if (this.canSwipe()) {
                this.swipeStartCoords = coords;
                this.swipeData = null;
            }
        };
        this.onSwipeMove = (moveCoords) => {
            if (this.canSwipe() && this.swipeStartCoords) {
                this.swipeData = Object.assign(Object.assign({}, moveCoords), { distanceX: moveCoords.x - this.swipeStartCoords.x, distanceY: moveCoords.y - this.swipeStartCoords.y });
            }
        };
        this.onSwipeEnd = (endCoords) => {
            if (this.canSwipe() && this.swipeData) {
                const isHorizontalSwipe = Math.abs(this.swipeData.distanceX) >= Math.abs(this.swipeData.distanceY);
                const distance = endCoords.x - this.swipeStartCoords.x;
                const isGreaterThanThreshold = Math.abs(distance) > SWIPE_THRESHOLD;
                if (!isHorizontalSwipe || !isGreaterThanThreshold || hasSelection(this.assetViewer.container)) {
                    return;
                }
                const direction = distance < 0 ? SwipeDirection.Left : SwipeDirection.Right;
                switch (direction) {
                    case SwipeDirection.Left:
                        this.next();
                        break;
                    case SwipeDirection.Right:
                        this.previous();
                        break;
                }
            }
            this.swipeStartCoords = null;
            this.swipeData = null;
        };
        this.next = () => {
            if (this.assetViewer.canNavigateToNext())
                this.assetViewer.next();
        };
        this.previous = () => {
            if (this.assetViewer.canNavigateToPrevious())
                this.assetViewer.previous();
        };
        this.init = (assetViewer) => {
            this.assetViewer = assetViewer;
            this.assetViewer.container.style.touchAction = 'pan-y pinch-zoom'; // tell Edge we control pan-x
            this.addEventListeners();
        };
        this.destroy = () => {
            this.removeEventListeners();
            this.swipeStartCoords = null;
            this.swipeData = null;
        };
    }
    addEventListeners() {
        this.assetViewer.container.addEventListener('mousedown', this.onMouseDown);
        this.assetViewer.container.addEventListener('mousemove', this.onMouseMove);
        this.assetViewer.container.addEventListener('mouseup', this.onMouseUp);
        this.assetViewer.container.addEventListener('touchstart', this.onTouchStart);
        this.assetViewer.container.addEventListener('touchmove', this.onTouchMove);
        this.assetViewer.container.addEventListener('touchend', this.onTouchEnd);
    }
    removeEventListeners() {
        this.assetViewer.container.removeEventListener('mousedown', this.onMouseDown);
        this.assetViewer.container.removeEventListener('mousemove', this.onMouseMove);
        this.assetViewer.container.removeEventListener('mouseup', this.onMouseUp);
        this.assetViewer.container.removeEventListener('touchstart', this.onTouchStart);
        this.assetViewer.container.removeEventListener('touchmove', this.onTouchMove);
        this.assetViewer.container.removeEventListener('touchend', this.onTouchEnd);
    }
}
//# sourceMappingURL=swipe.service.js.map